// extracted by mini-css-extract-plugin
export default {"selected":"styles---selected---I7BTU"};